<template>
  <v-layout column>
    <!-- ADD END DATE -->
    <v-dialog v-model="showAddEndDate" persistent max-width="480">
      <add-end-date
        :user-data="userDataToEdit"
        @cancelAddEndDate="showAddEndDate = false"
      />
    </v-dialog>
    <!-- RESET PASSWORD -->
    <v-dialog v-model="showResetPassword" persistent max-width="480">
      <v-card class="pa-3" width="480">
        <v-card-title class="headline">
          <font-awesome-icon
            class="mr-2"
            :style="{ color: '#424242' }"
            size="lg"
            :icon="['fal', 'undo-alt']"
          />
          Restablecer Contraseña
        </v-card-title>
        <v-card-text>
          <v-flex pa-3>
            <v-flex class="body-2 grey--text text--darken-2">
              Por favor confirmar que desea enviar un Email para
              <b>Restablecer Contraseña</b> del siguiente usuario:
            </v-flex>
            <v-flex py-3>
              <h4>{{ emailToResetPassword.fullName }}</h4>
              <h3>{{ emailToResetPassword.email }}</h3>
            </v-flex>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- v-if="showCancelBtn" -->
          <v-btn
            class="text-capitalize"
            color="red darken-1"
            dark
            depressed
            @click="cancel"
          >
            <font-awesome-icon
              class="mr-2"
              :style="{ color: '#FFFFFF' }"
              size="lg"
              :icon="['fal', 'times-circle']"
            />
            Cancelar
          </v-btn>

          <!-- v-if="showSendBtn" -->
          <v-btn
            class="text-capitalize"
            color="#466EA5"
            depressed
            dark
            @click="accept"
          >
            <font-awesome-icon
              class="mr-2"
              :style="{ color: '#FFFFFF' }"
              size="lg"
              :icon="['fal', 'paper-plane']"
            />
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <h2>Usuarios</h2>
    <v-flex>
      <p>
        Listado de usuarios:
      </p>
    </v-flex>
    <!-- BAR -->
    <v-layout class="bar-style max-min-width" mb-3 px-3 pt-2>
      <v-flex>
        Total Usuarios:
        <b>{{ users.length }}</b>
      </v-flex>
      <v-flex>
        Operativos:
        <b>
          {{ users.filter(item => item.role === 0).length }}
        </b>
      </v-flex>
      <v-flex>
        Administrativos:
        <b>
          {{ users.filter(item => item.role === 1).length }}
        </b>
      </v-flex>
      <v-flex>
        Lideres Funcionales:
        <b>
          {{ users.filter(item => item.role === 2).length }}
        </b>
      </v-flex>
      <v-flex>
        Administradores ODS:
        <b>
          {{ users.filter(item => item.role === 3).length }}
        </b>
      </v-flex>
    </v-layout>
    <!-- DATA TABLE -->
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar"
          single-line
          hide-details
          clearable
          color="#C46D24"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="users"
        :search="search"
        class="elevation-1"
        rows-per-page-text="Cantidad de filas por página:"
        no-data-text="No se encontraron Datos relacionados."
        no-results-text="No se encontraron Resultados relacionados."
        :rows-per-page-items="[5, 10, 25, { text: 'Todas', value: -1 }]"
      >
        <template v-slot:items="props">
          <td>{{ props.item.email }}</td>
          <td class="text-xs-center">{{ props.item.firstName }}</td>
          <td class="text-xs-center">{{ props.item.lastName }}</td>
          <td class="text-xs-center">{{ roles.get(props.item.role) }}</td>
          <td class="text-xs-center">{{ odsProcess(props.item.ods) }}</td>
          <td class="text-xs-center">{{ props.item.endDate }}</td>
          <td class="text-xs-center">
            <!-- ACTIVATE USER ICON-->
            <v-tooltip left v-if="props.item.active === 1">
              <template v-slot:activator="{ on }">
                <font-awesome-icon
                  class="ml-3"
                  :style="{ color: '#4CAF50' }"
                  size="sm"
                  :icon="['fal', 'user-check']"
                  v-on="on"
                />
              </template>
              <span>Usuario Activo</span>
            </v-tooltip>
            <!-- DEACTIVATED USER ICON-->
            <v-tooltip left v-if="props.item.active === 0">
              <template v-slot:activator="{ on }">
                <font-awesome-icon
                  class="ml-3"
                  :style="{ color: '#F44336' }"
                  size="sm"
                  :icon="['fal', 'user-slash']"
                  v-on="on"
                />
              </template>
              <span>Usuario Desactivado</span>
            </v-tooltip>
          </td>
          <td class="justify-center align-center layout px-0">
            <!-- <v-btn
              fab
              flat
              small
              depressed
              color="#C46D24"
              class="text-capitalize caption"
              @click="
                resetPasswordOpen({
                  email: props.item.email,
                  fullName: `${props.item.firstName} ${props.item.lastName}`
                })
              "
            > -->
            <!-- DEACTIVATE USER -->
            <v-tooltip left v-if="props.item.readyToDeactivate">
              <template v-slot:activator="{ on }">
                <font-awesome-icon
                  class="icon-pointer"
                  :style="{ color: '#C46D24' }"
                  size="sm"
                  :icon="['fal', 'user-slash']"
                  @click="
                    deactivateUserIn({
                      uid: props.item.uid,
                      email: props.item.email,
                      active: props.item.active,
                      fullName: `${props.item.firstName} ${props.item.lastName}`
                    })
                  "
                  v-on="on"
                />
              </template>
              <span>Desactivar Usuario</span>
            </v-tooltip>
            <!-- END DATE -->
            <v-tooltip left v-if="props.item.role < 2">
              <template v-slot:activator="{ on }">
                <font-awesome-icon
                  class="ml-2 icon-pointer"
                  :style="{ color: '#C46D24' }"
                  size="sm"
                  :icon="['fal', 'calendar-times']"
                  @click="
                    addEndDate({
                      uid: props.item.uid,
                      email: props.item.email,
                      startDate: props.item.startDate,
                      fullName: `${props.item.firstName} ${props.item.lastName}`
                    })
                  "
                  v-on="on"
                />
              </template>
              <span>Agregar Fecha Final</span>
            </v-tooltip>
            <!-- RESET PASSWORD -->
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <font-awesome-icon
                  class="ml-2 icon-pointer"
                  :style="{ color: '#C46D24' }"
                  size="sm"
                  :icon="['fal', 'undo-alt']"
                  @click="
                    resetPasswordOpen({
                      email: props.item.email,
                      fullName: `${props.item.firstName} ${props.item.lastName}`
                    })
                  "
                  v-on="on"
                />
              </template>
              <span>Restablecer Contraseña</span>
            </v-tooltip>
            <!-- CHANGE PASSWORD -->
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <font-awesome-icon
                  class="ml-2 icon-pointer"
                  :style="{ color: '#C46D24' }"
                  size="sm"
                  :icon="['fal', 'exchange']"
                  @click="changePassTable(props.item)"
                  v-on="on"
                />
              </template>
              <span>Cambiar Contraseña</span>
            </v-tooltip>
            <!-- </v-btn> -->
          </td>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Su busqueda: "{{ search }}" no se encontró.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import AddEndDate from "./AddEndDate";

const roleMap = new Map([
  [0, "Operativo"],
  [1, "Administrativo"],
  [2, "Lider Funcional"],
  [3, "Administrador ODS"]
]);

export default {
  name: "UsersTable",
  components: {
    AddEndDate
  },
  data() {
    return {
      userDataToEdit: {},
      showAddEndDate: false,
      showResetPassword: false,
      emailToResetPassword: "",
      search: "",
      headers: [
        { text: "Email", align: "left", value: "email" },
        { text: "Nombres", align: "center", value: "firstName" },
        { text: "Apellidos", align: "center", value: "lastName" },
        { text: "Rol", align: "center", value: "role" },
        { text: "ODS", align: "center", value: "ods" },
        { text: "Fecha de Retiro", align: "center", value: "endDate" },
        { text: "Estado", align: "center", value: "active" },
        { text: "Acciones", align: "center", value: "actions", sortable: false }
      ],
      roles: roleMap
    };
  },
  computed: {
    ...mapGetters(["users"])
  },
  methods: {
    ...mapActions([
      "showGeneralMessage",
      "deactivateUser",
      "changePass",
      "resetPassword"
    ]),
    deactivateUserIn(user) {
      console.log("DEACTIVATE USER", user);
      if (user.active === 0) {
        const payload = {
          showMessage: true,
          showCancelBtn: false,
          showSendBtn: false,
          showOkBtn: true,
          action: "",
          data: null,
          messageTitle: "Usuario Desactivado",
          messageInfo: `El usuario ${
            user.fullName
          } ya se encuentra desactivado.`
        };
        this.$store.commit("SET_GENERAL_MESSAGE", payload);
      } else {
        const payload = {
          showMessage: true,
          showCancelBtn: true,
          showSendBtn: true,
          showOkBtn: false,
          action: "deactivateUser",
          data: user,
          messageTitle: "Confirmar Desactivar Usuario",
          messageInfo: `Esta a punto de DESACTIVAR a: ${
            user.fullName
          }; por favor confirmar enviando, o cancelar sí es el caso.`
        };
        this.showGeneralMessage(payload);
        // this.deactivateUser(user);
      }
    },
    addEndDate(user) {
      console.log("ADD END DATE FOR:", user);
      this.userDataToEdit = user;
      this.showAddEndDate = true;
    },
    changePassTable(item) {
      this.$store.commit("SET_USER_TO_CHANGE_PASSWORD", item);
      this.changePass(true);
    },
    accept() {
      console.log("SEND RSTP!");
      this.resetPassword(this.emailToResetPassword.email);
      this.showResetPassword = false;
      this.emailToResetPassword = "";
    },
    cancel() {
      this.showResetPassword = false;
    },
    resetPasswordOpen(user) {
      this.emailToResetPassword = user;
      this.showResetPassword = true;
    },
    odsProcess(ods) {
      const typeOds = typeof ods;
      // console.log(typeOds);
      let odsRes = "";
      if (typeOds !== "string") {
        ods.forEach(element => {
          odsRes = odsRes === "" ? element : `${odsRes} - ${element}`;
        });
      } else odsRes = ods;
      return odsRes;
    }
  }
};
</script>

<style lang="stylus" scoped>
h3
  color #424242
  font-weight 600
  font-size 16px

h4
  color #616161

.icon-pointer
  cursor pointer

.icon-pointer:hover
  opacity 0.7

.max-min-width
  max-width 1024px
  min-width 1024px

.bar-style
  background-color #C46D24
  border-radius 8px
  height 45px
  font-size 18px
  color white
</style>
